<template>
<div>

<div @click="showPreview">
 <!-- <div  slot="icon"> -->
      <slot name="icon" >
       <van-icon name="video" size="25"/>
      </slot>
  <!-- </div> -->
</div>
  <!-- 视频播放 -->
  <van-overlay :show="showvideoplay">
    <div class="video-warp">
      <div class="content">
        <video
          controls
          controlslist="nodownload  noremoteplayback"
          :disablePictureInPicture="true"
          style="width: 100%; height: 100%; object-fit: contain"
          :src="url"
          ref="video"
        ></video>
        <div class="close" @click="stopVideo">
          <img src="@/assets/appeal/close.png" width="32" alt="">
        </div>
      </div>
    </div>
  </van-overlay>
</div>
</template>
<script>
  // import { uploadFileOss } from "@/api/oss";
 //文件上传前校验
export default {
  model: {
    prop: "upLoader",
    event: "change",
  },
  props: {
    upLoader:{
      type:Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    copyUpLoader: {
      get() {
        return this.upLoader
      },
      set(val) {
        this.$emit("change", val);
      }
    }
  },

  data () {
    return {
      play:require("@/assets/appeal/play.png"),
      showvideoplay:false,
      videoUrl:'',
      video:null
    }
  },
  mounted () {
    
  },
  methods:{


  //视频播放
    showPreview(){
      this.showvideoplay = true;
    },
  //视频暂停
    stopVideo(){
          this.showvideoplay = false;
          this.$refs.video.pause();
    }
  }

}
</script>


<style lang="less" scoped>
  /deep/.van-uploader__upload {
    &-text {
      margin-top: 0;
    }
    &-icon {
      margin-top: 15px;
    }
  }
  //视频样式
  .preview-cover {
    height: 100%;
    // .fj(center,center);
              display: flex;
  justify-content: center;
  align-items: center;
    .coverImg {
      width: 40px;
      height: 40px;
    }
  }

  .video-warp {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 100px;
    .content {
      position: relative;
      width: 300px;
      height: 200px;
      video::-webkit-media-controls-enclosure {
        overflow: hidden;
      }
      video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
      }
      .close {
        position: absolute;
        // background-image: require("@/assets/appeal/play.png");
        // background-repeat: no-repeat;
        // background-size: 100% 100%;
          display: flex;
  justify-content: center;
  align-items: center;
        width: 32px;
        height: 32px;
        text-align: center;
        left: 50%;
        transform: translate(-50%);
        color: #fff;
      }
    }
  }
</style>
